import { useUserNotification } from 'hooks/useUserNotification';
import { IntlKey } from 'locales';
import { useCallback } from 'react';
import { Msg } from 'state/notifications/notification.model';

export type SimpleUserNotification = {
  success: (message: string) => void;
  warn: (message: string) => void;
  error: (message: string) => void;
};

export function useSimplerUserNotification(title: IntlKey): SimpleUserNotification {
  const userNotifier = useUserNotification();

  const success = useCallback(
    (message: string) => {
      userNotifier.success({
        title: { id: title } as Msg,
        content: [message],
      });
    },
    [userNotifier, title],
  );

  const warn = useCallback(
    (message: string) => {
      userNotifier.warn({
        title: { id: title } as Msg,
        content: [message],
      });
    },
    [userNotifier, title],
  );

  const error = useCallback(
    (message: string) => {
      userNotifier.error({
        title: { id: title } as Msg,
        content: [message],
      });
    },
    [userNotifier, title],
  );

  return {
    success,
    warn,
    error,
  };
}
